<template>
    <div id="nosotros" class="welcome">
        <b-container>
            <b-row>
                <b-col>
                    <h1>Welcome</h1>
                    <p>Espacio Kokolet es más que un showroom o una concept store; es el hogar de nuestra marca, de nuestra filosofía y sin duda un lugar diseñado para brindar experiencias únicas.</p>
                    <p>Aquí, reunimos marcas exclusivas y seleccionadas para ofrecer un entorno innovador donde la creatividad y el estilo se encuentran</p>
                    <p class="socials">
                        <a href="https://www.facebook.com/Kokolet.mx" target="_blank"><img src="../assets/img/Facebook.png" alt=""></a>
                        <a href="https://www.instagram.com/kokolet.mx/" target="_blank"><img src="../assets/img/Instagram.png" alt=""></a>
                        <a href="https://api.whatsapp.com/send/?phone=525549287238&amp;app_absent=0"><img src="../assets/img/Whatsapp.png" alt=""></a>
                        <a href="https://www.tiktok.com/@kokoletmx" target="_blank"><img src="../assets/img/tiktok.png" alt=""></a>
                    </p>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    export default {

    }
</script>

<style scoped>
h1{
    color: #D37353;
    font-family: "Cedarville Cursive", serif;
    font-size: 100px;
}
p{
    font-size: 20px;
    max-width: 90%;
    margin-left: auto;
    margin-right: auto;
}
.socials{
    margin-top: 20px;
}
.socials a{
    margin: 10px;
}
.welcome{
    padding: 150px 0;
}

@media (max-width: 992px){
    .welcome{
        padding: 70px 0;
    }
    h1{
        font-size: 80px;
    }
    p{
        font-size: 18px;
    }
}
</style>